module.exports = __webpack_public_path__ + "static/img/gglr2.704aa62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/gglr2.png
// module id = BEVX
// module chunks = 0